<template>
    <v-row class="mt-1">
        <v-col cols="12">
            <h1 class="text-brand">Marking</h1>
            <p class="lead">View tasks that are ready for marking.</p>
        </v-col>
        <template v-if="taskStats">
            <v-col cols="6">
                <v-card class="h-100 d-flex flex-column justify-space-between">
                    <h2>Ready for marking</h2>
                    <p>
                        {{ taskStats?.ready_for_marking || 'No' }} task{{
                            taskStats?.ready_for_marking != 1
                                ? 's belonging to your pupils are'
                                : ' belonging to one of your pupils is'
                        }}
                        ready for marking.
                    </p>
                    <p v-if="sharedMarking && sharedMarking.sharing_marking_from.length > 0">
                        {{ sharedMarking.sharing_marking_from.length }} other teacher{{
                            sharedMarking.sharing_marking_from.length != 1 ? 's have' : ' has'
                        }}
                        shared their marking with you.
                    </p>
                    <v-btn
                        class="order-3 mt-4 align-self-start"
                        variant="flat"
                        color="secondary-container"
                        to="/teacher/marking?status=submitted"
                        >Start marking</v-btn
                    >
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card class="h-100 d-flex flex-column justify-space-between">
                    <h2>Tasks assigned {{ taskStats.overdue_tasks > 0 ? 'and overdue' : '' }}</h2>
                    <p>
                        {{ taskStats?.pending_tasks || 0 }} task{{ taskStats?.pending_tasks != 1 ? 's are' : ' is' }}
                        <template v-if="taskStats.overdue_tasks == 0"> assigned. </template>
                        <template v-else>
                            assigned and {{ taskStats?.overdue_tasks || 0 }} task{{
                                taskStats?.overdue_tasks != 1 ? 's are' : ' is'
                            }}
                            overdue.
                        </template>
                    </p>
                    <v-btn
                        class="order-3 mt-4 align-self-start"
                        color="secondary-container"
                        to="/teacher/marking?status=assigned"
                        >View all</v-btn
                    >
                </v-card>
            </v-col>

            <v-col cols="6">
                <v-card class="h-100 d-flex flex-column justify-space-between">
                    <h2>Task archive</h2>
                    <p>
                        {{ taskStats?.completed_tasks + taskStats.awaiting_feedback }} task{{
                            taskStats?.completed_tasks + taskStats.awaiting_feedback != 1 ? 's have' : ' has'
                        }}
                        been completed.
                    </p>
                    <v-btn
                        class="order-3 mt-4 align-self-start"
                        color="secondary-container"
                        to="/teacher/marking?status=completed"
                        >View completed</v-btn
                    >
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card class="h-100 d-flex flex-column justify-space-between">
                    <h2>Shared Marking</h2>

                    <template v-if="sharedMarking">
                        <p v-if="sharedMarking.sharing_marking_with.length > 0">
                            You are currently sharing your marking with
                            {{ sharedMarking.sharing_marking_with.length }} other teacher{{
                                sharedMarking.sharing_marking_with.length != 1 ? 's' : ''
                            }}.
                        </p>

                        <p v-else>You are not currently sharing your marking with any other teachers.</p>
                    </template>
                    <v-btn class="order-3 mt-4 align-self-start" color="secondary-container" to="/teacher/manage-sharing"
                        >Manage Sharing</v-btn
                    >
                </v-card>
            </v-col>
        </template>
    </v-row>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'marking' } });

const router = useRouter();
const store = useTeacherStore();
store.fetchTaskStats();
store.fetchSchool();
store.fetchSharedMarking();
const { school, taskStats, sharedMarking } = storeToRefs(store);

if (school.value?.bypass_marking) {
    router.push('/teacher/marking?status=completed');
}
</script>
<style scoped lang="scss">
h2 {
    margin-top: 0;
}
</style>
